// src/app/pages/privacy/privacy.component.ts

import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css'],
})
export class PrivacyComponent implements OnInit {

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly privacyPageId =
    `${this.baseUrl}/privacy#privacy`;

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update(
      'Privacy Policy',
      'Privacy policy for lydialynnchristensen.com.',
      'privacy'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": this.privacyPageId,
      "url": `${this.baseUrl}/privacy`,
      "name": "Privacy Policy",
      "description": "Privacy policy for lydialynnchristensen.com.",
      "isPartOf": {
        "@id": this.seo.websiteId
      },
      "about": {
        "@id": this.seo.campaignId
      },
      "publisher": {
        "@id": this.seo.campaignId
      },
      "inLanguage": "en-US"
    });
  }
}